// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PlexSection specific styles matching your update-container styles */
.plex-settings-form {
  display: grid;
  gap: 4px;
  padding: 12px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.plex-input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  margin: 12px 0;
  border-radius: 8px;
  text-align: center;
  height: 6vh;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  background-color: var(--background-consistent);
}

.plex-input:focus {
  outline: none;
  box-shadow: 0 0 2px 2px #4CAF50;
}

.btn-update-plex-settings {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: bold;
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  margin: 12px 0;
  border-radius: 8px;
  text-align: center;
  height: 6vh;
  background-color: var(--theme-consistent);
  color: white;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.btn-update-plex-settings:active {
  transform: scale(0.98);
  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
}

.btn-update-plex-settings:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.plex-warning {
  margin: 12px 0;
  padding: 12px;
  background-color: var(--background-consistent);
  border-radius: 8px;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
}

.text-warning {
  color: var(--theme-consistent) !important;
  margin: 0;
  font-size: 16px;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .plex-input,
  .btn-update-plex-settings {
    font-size: 16px;
    padding: 8px;
    margin: 8px 0;
    height: auto;
    min-height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/plexSection.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;EACzC,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":["/* PlexSection specific styles matching your update-container styles */\n.plex-settings-form {\n  display: grid;\n  gap: 4px;\n  padding: 12px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.plex-input {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  margin: 12px 0;\n  border-radius: 8px;\n  text-align: center;\n  height: 6vh;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  background-color: var(--background-consistent);\n}\n\n.plex-input:focus {\n  outline: none;\n  box-shadow: 0 0 2px 2px #4CAF50;\n}\n\n.btn-update-plex-settings {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-weight: bold;\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  margin: 12px 0;\n  border-radius: 8px;\n  text-align: center;\n  height: 6vh;\n  background-color: var(--theme-consistent);\n  color: white;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.btn-update-plex-settings:active {\n  transform: scale(0.98);\n  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);\n}\n\n.btn-update-plex-settings:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.plex-warning {\n  margin: 12px 0;\n  padding: 12px;\n  background-color: var(--background-consistent);\n  border-radius: 8px;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n}\n\n.text-warning {\n  color: var(--theme-consistent) !important;\n  margin: 0;\n  font-size: 16px;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n  .plex-input,\n  .btn-update-plex-settings {\n    font-size: 16px;\n    padding: 8px;\n    margin: 8px 0;\n    height: auto;\n    min-height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
